import { render, staticRenderFns } from "./RewardWithPresence.vue?vue&type=template&id=3bf82b5a"
import script from "./RewardWithPresence.vue?vue&type=script&lang=js"
export * from "./RewardWithPresence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports